import React, { useState } from "react";
import {
    Box,
    Grid,
    Typography,
    Paper,
    InputBase,
    IconButton,
} from "@mui/material";
import { Add, DescriptionOutlined } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import { useSelector } from "react-redux";
import CustomDataTable from "../../components/DataTable";
import { IMAGE_URL } from "../../store/services/constants";
import colors from "../../styles/colors";
import Loader from "../../components/Loader";
import { toast } from "react-toastify";
import {  useFetchCategoriesQuery } from "../../store/services/categoriesService";
import { Icons } from "../../assets/Svgs";

const Categories = () => {
    const theme = useTheme();
    const words = useSelector((state) => state.authReducer.words);
    const { data, isLoading, error } = useFetchCategoriesQuery();



    const [search, setSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(1);

 
    const filteredData = data?.data?.filter((category) =>
        category.name.toLowerCase().includes(search.toLowerCase())
    );


    const columns = [
        {
            field: "image",
            label: "Image",
            render: (value) => (
                <img
                    src={IMAGE_URL + value || "/default-category.png"}
                    alt="Category"
                    style={{ width: "50px", height: "50px", borderRadius: "50%" }}
                />
            ),
        },
        { field: "name", label: "Category Name" },
        { field: "created_at", label: "Created At", render: (value) => new Date(value).toLocaleDateString(), },
        {
            field: "ads_count",
            label: "Total ads",
            render: (value, record) => (
                <Box
                    sx={{
                        backgroundColor: '#4CAF50',
                        //  : "#4CAF50",
                        color: "#fff",
                        padding: "7px 8px",
                        borderRadius: "4px",
                        textAlign: "center",
                        fontFamily: "PMe",
                        fontSize: 12,
                        maxWidth: 60,
                    }}
                >
                    {value}
                </Box>
            ),
        },
    ];

    return (
        <>
            <Box sx={{ padding: "16px", backgroundColor: "#F5F5F5" }}>
                <Loader open={isLoading} />
                <Grid container spacing={1} alignItems="center">
                    {/* Search Bar */}
                    <Grid item xs={12} sm={6} md={3} lg={3}>
                        <Paper
                            component="form"
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                borderRadius: "10px",
                                boxShadow: "none",
                                padding: "0.3rem",
                            }}
                        >
                            <Box sx={{ width: 2, borderRadius: 5, height: 20, backgroundColor: colors.primary, ml: 2 }} />
                            <InputBase
                                onChange={(e) => setSearch(e.target.value)} // Update search state
                                value={search} // Controlled input
                                sx={{ ml: 2, flex: 1, fontSize: 13, fontFamily: "PMe" }}
                                placeholder="Search Here"
                                inputProps={{ "aria-label": "search here" }}
                            />
                            <IconButton aria-label="search">
                                <Icons.searchIcon color={colors.primary} />
                            </IconButton>
                        </Paper>
                    </Grid>
                </Grid>
            </Box>

            {/* Data Table */}
            <Box sx={{ paddingRight: '16px', paddingLeft: '16px', backgroundColor: colors.bg }}>
                {isLoading ? (
                    <Typography></Typography>
                ) : error ? (
                    <Typography>Error loading customers</Typography>
                ) : (
                    <CustomDataTable
                        data={filteredData || []} // Use filtered data
                        columns={columns}
                        totalPages={data?.data?.last_page || 1}
                        currentPage={currentPage}
                        onPageChange={(page) => setCurrentPage(page)}

                    />
                )}
            </Box>

           </>
    );
};

export default Categories;




// import React, { useState } from "react";
// import {
//     Box,
//     Button,
//     Grid,
//     Typography,
//     Paper,
//     InputBase,
//     IconButton,
//     Dialog,
//     DialogTitle,
//     DialogContent,
//     DialogActions,
// } from "@mui/material";
// import { Add, DescriptionOutlined } from "@mui/icons-material";
// import { useTheme } from "@mui/material/styles";
// import { useSelector } from "react-redux";
// import CustomDataTable from "../../components/DataTable";
// // import { useFetchCategoriesQuery } from "../../store/services/categoryService";
// import { IMAGE_URL } from "../../store/services/constants";
// import colors from "../../styles/colors";
// import Loader from "../../components/Loader";
// import { toast } from "react-toastify";
// import { useDeleteCategoryMutation, useFetchCategoriesQuery } from "../../store/services/categoriesService";
// import { Icons } from "../../assets/Svgs";
// import AddCategoryDialog from "./NewCategory";
// import ActionMenu from "../../components/ActionMenu";
// import EditCategoryDialog from "./EditCategory";

// const Categories = () => {
//     const theme = useTheme();
//     const words = useSelector((state) => state.authReducer.words);

//     const [deleteCategory, { isLoading: isDeleting }] = useDeleteCategoryMutation();
//     const { data, isLoading, error } = useFetchCategoriesQuery();



//     const [search, setSearch] = useState("");
//     const [currentPage, setCurrentPage] = useState(1);
//     const [open, setOpen] = useState(false);

//     const [editModal, setEditModal] = useState(false);
//     const [selectedCustomer, setSelecetedCustomer] = useState({});

//     const [deleteModal, setDeleteModal] = useState(false);
//     const [deleteCustomerId, setDeleteCustomerId] = useState(null);






//     const filteredData = data?.data?.filter((category) =>
//         category.name.toLowerCase().includes(search.toLowerCase())
//     );


//     const handleDeleteCustomer = async () => {
//         if (!deleteCustomerId) return;
//         try {
//             await deleteCategory(deleteCustomerId).unwrap();
//             toast.success("Customer deleted successfully!");
//             setDeleteModal(false); // Close the dialog
//         } catch (error) {
//             toast.error("Failed to delete customer. Please try again.");
//             console.error(error);
//         }
//     };


//     const columns = [
//         {
//             field: "image",
//             label: "Image",
//             render: (value) => (
//                 <img
//                     src={IMAGE_URL + value || "/default-category.png"}
//                     alt="Category"
//                     style={{ width: "50px", height: "50px", borderRadius: "50%" }}
//                 />
//             ),
//         },
//         { field: "name", label: "Category Name" },
//         { field: "created_at", label: "Created At", render: (value) => new Date(value).toLocaleDateString(), },
//         {
//             field: "ads_count",
//             label: "Total ads",
//             render: (value, record) => (
//                 <Box
//                     sx={{
//                         backgroundColor: '#4CAF50',
//                         //  : "#4CAF50",
//                         color: "#fff",
//                         padding: "7px 8px",
//                         borderRadius: "4px",
//                         textAlign: "center",
//                         fontFamily: "PMe",
//                         fontSize: 12,
//                         maxWidth: 60,
//                     }}
//                 >
//                     {value}
//                 </Box>
//             ),
//         },

//         {
//             field: "Action",
//             label: "Action",
//             render: (value, record) => (
//                 <ActionMenu
//                     onAction={(action) => {
//                         if (action === "edit") {
//                             setSelecetedCustomer(record);
//                             setEditModal(true);
//                         } else if (action === "delete") {
//                             setDeleteCustomerId(record.id); // Set the selected customer ID
//                             setDeleteModal(true); // Open delete confirmation dialog
//                         }
//                     }}
//                     menuItems={[
//                         { label: "Edit", action: "edit" },
//                         { label: "Delete", action: "delete" },
//                     ]}
//                 />
//             ),
//         }


//     ];

//     return (
//         <>
//             <Box sx={{ padding: "16px", backgroundColor: "#F5F5F5" }}>
//                 <Loader open={isLoading} />
//                 <Grid container spacing={1} alignItems="center">

//                     {/* Search Bar */}
//                     <Grid item xs={12} sm={6} md={3} lg={3}>
//                         <Paper
//                             component="form"
//                             sx={{
//                                 display: "flex",
//                                 alignItems: "center",
//                                 borderRadius: "10px",
//                                 boxShadow: "none",
//                                 padding: "0.3rem",
//                             }}
//                         >
//                             <Box sx={{ width: 2, borderRadius: 5, height: 20, backgroundColor: colors.primary, ml: 2 }} />
//                             <InputBase
//                                 onChange={(e) => setSearch(e.target.value)} // Update search state
//                                 value={search} // Controlled input
//                                 sx={{ ml: 2, flex: 1, fontSize: 13, fontFamily: "PMe" }}
//                                 placeholder="Search Here"
//                                 inputProps={{ "aria-label": "search here" }}
//                             />
//                             <IconButton aria-label="search">
//                                 <Icons.searchIcon color={colors.primary} />
//                             </IconButton>
//                         </Paper>
//                     </Grid>

//                     {/* Action Buttons */}
//                     <Grid item xs={12} sm={6} md={4} lg={4}>
//                         <Box sx={{ display: "flex", gap: "10px", flexDirection: "row" }}>
//                             <Button
//                                 variant="outlined"
//                                 startIcon={<DescriptionOutlined sx={{ color: colors.primary }} />}
//                                 sx={{
//                                     borderRadius: "20px",
//                                     fontSize: 12,
//                                     padding: "8px 16px",
//                                     borderColor: colors.primary,
//                                     color: "#000",
//                                     fontFamily: "PMe",
//                                     textTransform: "none",
//                                 }}
//                             >
//                                 {words["Generate Report"]}
//                             </Button>
//                             <Button
//                                 onClick={() => setOpen(true)}
//                                 // variant="contained"
//                                 startIcon={<Add />}
//                                 sx={{
//                                     backgroundColor: colors.primary,
//                                     fontSize: 12,
//                                     color: "white",
//                                     fontFamily: "PMe",
//                                     borderRadius: "20px",
//                                     padding: "8px 16px",
//                                     textTransform: "none",
//                                 }}
//                             >
//                                 {words["New category"]}
//                             </Button>
//                         </Box>
//                     </Grid>
//                 </Grid>
//             </Box>

//             {/* Data Table */}
//             <Box sx={{ paddingRight: '16px', paddingLeft: '16px', backgroundColor: colors.bg }}>
//                 {isLoading ? (
//                     <Typography></Typography>
//                 ) : error ? (
//                     <Typography>Error loading customers</Typography>
//                 ) : (
//                     <CustomDataTable
//                         data={filteredData || []} // Use filtered data
//                         columns={columns}
//                         totalPages={data?.data?.last_page || 1}
//                         currentPage={currentPage}
//                         onPageChange={(page) => setCurrentPage(page)}

//                     />
//                 )}
//             </Box>

//             <AddCategoryDialog open={open} onClose={() => setOpen(false)} />
//             <EditCategoryDialog data={selectedCustomer} open={editModal} onClose={() => setEditModal(false)} />

//             <Dialog open={deleteModal} onClose={() => setDeleteModal(false)}>
//                 <DialogTitle
//                     sx={{ fontFamily: 'PSBo' }}
//                 >Are you sure?</DialogTitle>
//                 <DialogContent>
//                     <Typography
//                         sx={{ fontFamily: 'PRe' }}
//                     >
//                         Are you sure you want to delete this category?
//                     </Typography>
//                 </DialogContent>
//                 <DialogActions>
//                     <Button
//                         onClick={() => setDeleteModal(false)}
//                         variant="outlined"
//                         sx={{
//                             borderRadius: "20px",
//                             fontSize: 12,
//                             textTransform: "none",
//                             fontFamily: "PMe",
//                         }}
//                     >
//                         Cancel
//                     </Button>
//                     <Button
//                         onClick={handleDeleteCustomer}
//                         variant="contained"
//                         disabled={isDeleting}

//                         sx={{
//                             backgroundColor: colors.danger,
//                             fontSize: 12,
//                             color: "white",
//                             borderRadius: "20px",
//                             padding: "8px 16px",
//                             textTransform: "none",
//                             fontFamily: "PMe",
//                         }}
//                     >
//                         {isDeleting ? "Deleting..." : "Delete"}
//                     </Button>
//                 </DialogActions>
//             </Dialog>



//         </>
//     );
// };

// export default Categories;
